:host {
  display: block;
}

.spw-accordion-item {
  position: relative;
  &__content {
    position: relative;
    border-bottom: 1px solid var(--spw-color-themes-grey-grey-300);
  }

  &__trigger {
    display: block;
    text-decoration: none;

    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
    @include breakpoint(md) {
      position: relative;
    }

    &:focus-visible {
      outline: 3px solid var(--spw-ds-focus);
      outline-offset: -3px;
    }
  }
}
